import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-044add8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "monitoringdata" }
const _hoisted_2 = { class: "table__box" }
const _hoisted_3 = { class: "table__tr" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "table__header" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Date")
], -1))
const _hoisted_5 = { class: "table__body" }
const _hoisted_6 = { class: "table__tr" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "table__header" }, [
  /*#__PURE__*/_createElementVNode("div", null, "RR")
], -1))
const _hoisted_8 = { class: "table__body" }
const _hoisted_9 = { class: "table__tr" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "table__header" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Sedation")
], -1))
const _hoisted_11 = { class: "table__body" }
const _hoisted_12 = { class: "table__tr" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "table__header" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Diarrhea")
], -1))
const _hoisted_14 = { class: "table__body" }
const _hoisted_15 = { class: "table__tr" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "table__header" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Restraint")
], -1))
const _hoisted_17 = { class: "table__body" }
const _hoisted_18 = { class: "table__tr" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "table__header" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Reposition")
], -1))
const _hoisted_20 = { class: "table__body" }
const _hoisted_21 = { class: "table__tr" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "table__header" }, [
  /*#__PURE__*/_createElementVNode("div", null, "HCO3")
], -1))
const _hoisted_23 = { class: "table__body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chartData, (data) => {
            return (_openBlock(), _createElementBlock("div", { key: data }, _toDisplayString(data.PU_DATE), 1))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chartData, (data) => {
            return (_openBlock(), _createElementBlock("div", {
              key: data,
              class: _normalizeClass({'imputation': data.RESP_RATE?.imputation})
            }, _toDisplayString(typeof data.RESP_RATE === 'object' ? (data.RESP_RATE.value).toFixed(2): (data.RESP_RATE).toFixed(2)), 3))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chartData, (data) => {
            return (_openBlock(), _createElementBlock("div", {
              key: data,
              class: _normalizeClass({'imputation': data.SEDATION?.imputation})
            }, _toDisplayString(typeof data.SEDATION === 'object' ? (data.SEDATION.value): data.SEDATION), 3))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chartData, (data) => {
            return (_openBlock(), _createElementBlock("div", {
              key: data,
              class: _normalizeClass({'imputation': data.DIARRHEA?.imputation})
            }, _toDisplayString(typeof data.DIARRHEA === 'object' ? (data.DIARRHEA.value): data.DIARRHEA), 3))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chartData, (data) => {
            return (_openBlock(), _createElementBlock("div", {
              key: data,
              class: _normalizeClass({'imputation': data.RESTRAINT?.imputation})
            }, _toDisplayString(typeof data.RESTRAINT === 'object' ? (data.RESTRAINT.value): data.RESTRAINT), 3))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _createElementVNode("div", _hoisted_20, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chartData, (data) => {
            return (_openBlock(), _createElementBlock("div", {
              key: data,
              class: _normalizeClass({'imputation': data.REPOSITION?.imputation})
            }, _toDisplayString(typeof data.REPOSITION === 'object' ? data.REPOSITION.value : data.REPOSITION), 3))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _hoisted_22,
        _createElementVNode("div", _hoisted_23, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chartData, (data) => {
            return (_openBlock(), _createElementBlock("div", {
              key: data,
              class: _normalizeClass({'imputation': data.HCO3?.imputation})
            }, _toDisplayString(typeof data.HCO3 === 'object' ? (data.HCO3.value).toFixed(2): (data.HCO3).toFixed(2)), 3))
          }), 128))
        ])
      ])
    ])
  ]))
}